import APIClient from '@/shared/http/clients/api'

const resourceName = 'DespesaItem'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

const GetByDespesaId = (depesaId, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetByDespesaId/${depesaId}`, data, config)
const SendFiles = (despesaItemId, data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/SendFile/${despesaItemId}`, data, {
  ...config,
  transformRequest: [(d, headers) => {
    delete headers['Content-Type']
    return d
  }]
})
const DeleteFile = (despesaItemAnexoId, data = {}, config = {}) => APIClient.delete(`${APIBusinessCommon}/${resourceName}/DeleteFile/${despesaItemAnexoId}`, data, config)

const ExpenseAttachedItemRepository = {
  GetByDespesaId,
  SendFiles,
  DeleteFile
}

export default ExpenseAttachedItemRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/expenseattacheditem.js